<template>
  <div>
    <v-btn v-if="flgScrollLock" id="scroll-lock-btn" fab dark color="secondary" @click="scrollLock">
      <v-icon>lock</v-icon>
    </v-btn>
    <v-btn v-else id="scroll-lock-btn" fab dark color="secondary lighten-2" @click="scrollLock">
      <v-icon>lock_open</v-icon>
    </v-btn>
  </div>
</template>

<script>
export default {
  data() {
    return {
      flgScrollLock: false
    }
  },
  methods: {
    scrollLock() {
      if(this.flgScrollLock == true) {
        this.flgScrollLock = false;
      } else {
        this.flgScrollLock = true;
      }

      this.$emit('scroll-lock', this.flgScrollLock);
    }
  }
}
</script>